import { render } from "./project-list.vue?vue&type=template&id=7f379c5a&scoped=true"
import script from "./project-list.vue?vue&type=script&lang=js"
export * from "./project-list.vue?vue&type=script&lang=js"

import "./project-list.vue?vue&type=style&index=0&id=7f379c5a&lang=scss"
import "./project-list.vue?vue&type=style&index=1&id=7f379c5a&lang=scss&scoped=true"

import exportComponent from "/Users/jigarpyunt/Desktop/ArrowDT/Git/SDB/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f379c5a"]])

export default __exports__